import { ButtonProps } from '@jusbrasil-rc/button'

import { FlashtagProps } from './flashtag'

export const buttonColorMapping: Record<
  NonNullable<FlashtagProps['type']>,
  ButtonProps['color']
> = {
  info: 'blue',
  warning: 'white',
}
